<template>
  <v-app>
    <!-- <v-toolbar app class="red darken-4 white--text">
      <v-toolbar-title class="headline text-uppercase">
        <span>Compliance</span>
        <span class="font-weight-light">FORGE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

        <span class="mr-2  white--text">Development</span>
      
    </v-toolbar> -->

    <v-content class="white">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import DataTable from '@/components/DataTable'

export default {
  name: 'App',
  components: {
    DataTable
  },
  data () {
    return {
      //
    }
  }
}
</script>